import get from 'lodash/get';
import { getDiff } from 'components/utils/search';
import { PresetQuery } from 'components/Presets/Selector/graphql';
import { PLACEMENT_STATUSES } from 'components/Placement/constants';

export async function getPresetSearch(apolloClient, presetId, flat) {
  const response = await apolloClient.query({
    query: PresetQuery,
    fetchPolicy: 'cache-first',
    variables: {
      id: presetId,
    },
  });

  if (!response.data) {
    throw new Error();
  }

  if (!response.data) {
    return {};
  }

  const { preset } = response.data;

  if (!flat || !preset.search) {
    return preset.search;
  }

  const { f, ...rootParams } = preset.search;

  const result = { ...rootParams, ...f };
  delete result.presetId;

  // Filter out invalid status values from old presets
  if (result.status && Array.isArray(result.status)) {
    result.status = result.status.filter((s) => PLACEMENT_STATUSES.includes(s));
  }

  return result;
}

export function mergePresetParams(params, defaultParams, presetParams) {
  if (!presetParams) {
    return params;
  }

  const urlParams = getDiff(defaultParams, params);

  const initialParams = {
    ...params,
  };

  Object.entries(presetParams).forEach(([key, presetValue]) => {
    const paramsValue = urlParams[key];
    const defaultValue = defaultParams[key];
    if (
      presetValue &&
      paramsValue &&
      typeof presetValue === 'object' &&
      typeof paramsValue === 'object' &&
      !Array.isArray(paramsValue)
    ) {
      initialParams[key] = { ...presetValue, ...paramsValue };
    } else {
      initialParams[key] = paramsValue || presetValue || defaultValue;
    }
  });

  return initialParams;
}

export const createParseInitialParams = (
  user,
  apolloClient,
  presetKey,
) => async (initialParams, defaultParams, diff) => {
  const params = { ...initialParams };

  const defaultPresetId = get(user, `presets.${presetKey}`);
  if (!Object.keys(diff).length && defaultPresetId) {
    params.presetId = defaultPresetId;
  }

  if (params.presetId) {
    try {
      const presetParams = await getPresetSearch(
        apolloClient,
        params.presetId,
        true,
      );

      return mergePresetParams(params, defaultParams, presetParams);
    } catch (e) {
      delete params.presetId;
    }
  }
  return params;
};

export const createaGetParamsToBeHidden = (apolloClient) => async (params) => {
  if (params.presetId) {
    return getPresetSearch(apolloClient, params.presetId, true);
  }
  return null;
};
